import { Component, OnInit, OnDestroy, AfterViewChecked, AfterViewInit, ElementRef, ViewChild, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SupportService } from '@components/support/support.service';
import { SharedService } from '@shared/shared.service';
import { Router } from '@angular/router';
import { environment } from '@myenv/environment';
import { AuthenticationService } from '@layouts/login/authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { enMessage } from '@shared/en-us-message';
import { configMessage } from '@shared/config-message';
import { NgForm } from '@angular/forms';


@Component({
    selector: 'app-advanced-search',
    templateUrl: './advanced-search.component.html',
    styleUrls: ['./advanced-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdvancedSearchComponent implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit {
  @ViewChild('inputElement') inputOne!: ElementRef;
  modules: any = [];
  moduleName = 'SUPPORT';
  permissionAuthorities: any = {};
  impersonatePermission: any = {};
  timeout: any = null;
  searchModel: any = {
    supportTypeVal: ''
  };
  public users: any = [];
  public devices: any = [];
  public vehicles: any = [];
  isLoading = false;
  currentUser: any = {};
  noResults = false;
  alertMessage: string = '';
  alertType: string = 'danger';
  showAlert: boolean = false;
  companyName = environment.companyName;
  custId!: number;
  typeValue!: string;
  impersonate = false;
  responseMessage: any = {};
  permissionModules: any = [];
  currentPermissionModules: any = [];
  /**
   * For date format
   */
  public isoDateTimeFormat = environment.isoDateTimeFormat;
  deviceStatus = configMessage.deviceStatus;
  deviceStatusClass = configMessage.deviceStatusClass;
  showJiraTicketModal = false;
  account: any = {};
  jira = {
    customerAccountId: "",
    customerEmail: "",
    description: "",
    attachments: [] as File[],
  };

  constructor(public router: Router,
    private supportService: SupportService,
    private sharedService: SharedService,
    private title: Title,
    private _cookieService: CookieService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.title.setTitle('Support'+ environment.title_text);
    this.searchModel.searchType = 'email';
    this.searchModel.searchGroup = 'User';
    this.modules = JSON.parse(localStorage.getItem('accessRoleModules') || '[]');
    this.permissionAuthorities = this.modules.find((module: any) => module.name === this.moduleName);
    this.impersonatePermission = this.modules.find((module: any) => module.name === 'IMPERSONATE');
    this.currentPermissionModules = JSON.parse(localStorage.getItem('permissionModules') || '[]');
    const supportSearch = JSON.parse(localStorage.getItem('supportSearch') || '{}');
    if (supportSearch && supportSearch.searchGroup && supportSearch.supportTypeVal && supportSearch.searchType) {
      this.searchModel.searchGroup = supportSearch.searchGroup;
      this.searchModel.searchType = supportSearch.searchType;
      this.searchModel.supportTypeVal = supportSearch.supportTypeVal;
      this.onSearch();
    }
  }

  ngAfterViewInit() {
    // Initial sync after view initialization
    setTimeout(() => {
      this.syncDatatableHeaderWidth();
    }, 500);
  }

  @HostListener('window:resize')
  onResize() {
    // Sync on window resize
    setTimeout(() => {
      this.syncDatatableHeaderWidth();
    }, 100);
  }

  // Records the group name on select change
  onSlotChange(e: any) {
    const selectedValue = e.target.value;
    this.searchModel.searchGroup = 'User';
    this.onSearch();
  }

  searchDataOnChange() {
    if(this.searchModel.searchValue && this.searchModel.searchId) {
      this.onSearch();
    }
  }

  selectInput() {
    const inputElem = <HTMLInputElement>this.inputOne.nativeElement;
    inputElem.select();
  }

  public inputValidator(event: any) {
    // If search type is phoneNumber, allow numbers and + sign
    if (this.searchModel.searchType === 'phoneNumber') {
      // Allow numbers and + sign only
      let value = event.target.value.replace(/[^0-9+]/g, '');
      // Limit to reasonable length (e.g., 15 characters to allow country code + number)
      if (value.length > 15) {
        value = value.substring(0, 15);
      }
      event.target.value = value;
      this.searchModel.supportTypeVal = value;
      this.onSearch();
    } else {
      // Original validation for other search types
      const pattern = /^[_\-@.,a-zA-Z0-9\s]*$/;
      if (!pattern.test(event.target.value)) {
        event.target.value = event.target.value.replace(/[^_\-@.,a-zA-Z0-9\s]/g, '');
        this.searchModel.supportTypeVal = event.target.value;
        this.onSearch();
      } else {
        this.onSearch();
      }
    }
  }
  // 'show' button function for User group search
  // To search for users based on filter
  onSearch() {
    clearTimeout(this.timeout);
    let global = this;
    this.timeout = setTimeout(function () {
      if (global.searchModel.supportTypeVal) {
        global.users = [];
        global.devices = [];
        global.vehicles = [];
        global.typeValue = global.searchModel.supportTypeVal.trim();
        const searchGroup = global.searchModel.searchGroup;
        const supportSearch = {
          searchGroup: searchGroup,
          searchType: global.searchModel.searchType,
          supportTypeVal: global.typeValue
        };
        localStorage.setItem('supportSearch', JSON.stringify(supportSearch));
        if (searchGroup === 'User') {
          global.searchUser();
        } else if (searchGroup === 'Device') {
          global.searchDevice();
        } else if (searchGroup === 'Vehicle') {
          global.searchVehicle();
        }
      } else {
        global.users = [];
        global.devices = [];
        global.vehicles = [];
      }
    }, 1500);
  }

  // search all users
  searchUser() {
    // Encode the value for URL: encodeURIComponent will encode + as %2B
    const encodedValue = encodeURIComponent(this.typeValue);
    this.supportService
      .onSearchUser(this.searchModel.searchType, encodedValue)
      .subscribe(
        (res) => {
          if (res && res.status === "success" && res.data.accountId) {
            // Map the response data to match the table structure
            const userData = {
              firstName: res.data.firstName || "",
              lastName: res.data.lastName || "",
              emailId: res.data.email || "",
              userName: res.data.username || "",
              customerId: res.data.accountId || "",
              phoneNumber: res.data.phoneNumber || "",
              OS: res.data.OS || "",
              phoneModel: res.data.phoneModel || "",
              appVersion: res.data.appVersion || "",
              latestAppVersion: res.data.latestAppVersion || "",
              latestServerVersion: res.data.latestServerVersion || "",
              // Add userType for View button condition (defaulting to SUPER_USER since it's a customer account)
              userType: "SUPER_USER",
            };
            // Wrap in array for table display
            this.users = [userData];
          } else if (Array.isArray(res)) {
            // Fallback for old API response format (array)
            this.users = res;
          } else {
            this.users = [];
          }
          this.users.length === 0
            ? (this.noResults = true)
            : (this.noResults = false);
          setTimeout(() => {
            this.syncDatatableHeaderWidth();
            setTimeout(() => this.syncDatatableHeaderWidth(), 200);
          }, 100);
        },
        (error) => {
          this.users = [];
          this.noResults = true;
          this.sharedService.getErrorMsg(error);

          // Extract error message for ngx-bootstrap alert
          let errorMsg = 'An error occurred while searching for users.';
          if (error.error && error.error.errorCode) {
            const errorCode = error.error.errorCode;
            const errorMessage = enMessage[errorCode];
            if (errorMessage) {
              errorMsg = errorMessage;
            }
          } else if (error.error && error.error.message) {
            errorMsg = error.error.message;
          } else if (error.message) {
            errorMsg = error.message;
          }

          if (error.status == 404 && errorMsg == 'CH001' && errorMsg.length > 0) {
            this.alertMessage = 'Account not found';
          }
          else {
            this.alertMessage = errorMsg;
          }
          this.alertType = 'danger';
          this.showAlert = true;
          setTimeout(() => {
            this.showAlert = false;
          }, 5000);
        }
      );
  }

  // search all devices
  searchDevice() {
    this.sharedService.onSearchDevice(this.searchModel.searchType, this.typeValue).subscribe(res => {
      this.devices = res;
      (this.devices.length === 0) ? this.noResults = true : this.noResults = false;
      setTimeout(() => {
        this.syncDatatableHeaderWidth();
        setTimeout(() => this.syncDatatableHeaderWidth(), 200);
      }, 100);
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  // search all vehicles
  searchVehicle() {
    this.sharedService.onSearchVehicle(this.searchModel.searchType, this.typeValue).subscribe(res => {
      this.vehicles = res;
      (this.vehicles.length === 0) ? this.noResults = true : this.noResults = false;
      setTimeout(() => {
        this.syncDatatableHeaderWidth();
        setTimeout(() => this.syncDatatableHeaderWidth(), 200);
      }, 100);
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  // get customer id for device, vehicle and search user based on that
  getCustomerId(value: any) {
    this.supportService.onSearchUser('customerId', +value).subscribe(res => {
      // this.getCurrentUser(res[0]);
      this.findSuperUser(res);
    });
  }

  findSuperUser(data: any) {
    data.map((item: any) => {
      if (item.userType === 'SUPER_USER') {
        this.getCurrentUser(item);
        return;
      }
    });
  }

  // get the user info
  /* To Navigate to user-info page on clicking show button in table row
      passing the user name and user id as query params
  */
  getCurrentUser(value: any) {
    try {
      this.currentUser = value;
      this.router.navigate(['/support/user-info'], {
        queryParams: {
          id: value.userId,
          name: value.userName
        }
      });
    } catch (e) {
      console.log(e instanceof Error ? e.message : e);
    }
  }

  impersonateUser(user: any) {
    // Store accountId from the user data (from search response)
    const accountId = user.customerId || user.accountId;
    if (accountId) {
      localStorage.setItem("supportAccountId", accountId.toString());
    }
    // Store account information for display
    const accountInfo = {
      username: user.userName || user.username || '',
      email: user.emailId || user.email || '',
      os: user.OS || '',
      customerAppVersion: user.appVersion || '',
      latestAppVersion: user.latestAppVersion || '',
      latestServerVersion: user.latestServerVersion || '',
    };
    localStorage.setItem("supportAccountInfo", JSON.stringify(accountInfo));
    // Set support view mode flag
    localStorage.setItem("supportViewMode", "true");
    // Navigate directly to /chargers page
    this.router.navigate(["/chargers"]);

    // Original impersonation code commented out:
    // this.authenticationService.impersonate(user.userId).subscribe(
    //   (res) => {
    //     if (res.accessToken) {
    //       let base64Token = res.accessToken;
    //       this.authenticationService.setHeaders(base64Token);
    //       this._cookieService.set("user", "impersonateUser");
    //       if (this._cookieService.get("user")) {
    //         this.impersonate = true;
    //       }
    //       // Removed getUserPreferences() call - no login call needed
    //       this.tokenScenario(res);
    //     } else if (res.status == 404) {
    //       this.authenticationService.setHeaders(
    //         this.authenticationService.getHeaders()
    //       );
    //       const errorCode = res.errorCode;
    //       const errorMessage = enMessage[errorCode];
    //       this.responseMessage = { success: false, message: errorMessage };
    //       this.sharedService.setResponseMessage(this.responseMessage);
    //     }
    //   },
    //   (error) => {
    //     var token = this.authenticationService.getHeaders();
    //     this.authenticationService.setHeaders(token);
    //     if (error.status == 404) {
    //       this.sharedService.getErrorMsg(error);
    //     } else {
    //       this.sharedService.getErrorMsg(error);
    //     }
    //   }
    // );
  }

  // To get user preferences
  getUserPreferences() {
    // Get the User Preferences by making a seperate API call
    this.authenticationService.userPreferences().subscribe(responseInfo => {
      if (responseInfo) {
        localStorage.setItem('preferences', JSON.stringify(responseInfo));
      }
      if (responseInfo.liveHistory || responseInfo.live.header) {
        if (responseInfo.liveHistory && responseInfo.liveHistory.header) {
          this.authenticationService.liveHistoryPrefrences(responseInfo.liveHistory.header);
        }
        // if (responseInfo.live && responseInfo.live.header) {
        //   this.authenticationService.livePrefrences(responseInfo.live.header);
        // }
      }
    }, error => {
      this.sharedService.getErrorMsg(error);
    });
  }

  // setting the permissions and impersonating the user.
  tokenScenario(res: any) {
    this.authenticationService.getLoggedUser().subscribe((reponseInFo) => {
      if (res.status === 404) {
        const errorCode = res.errorCode;
        const errorMessage = enMessage[errorCode];
        this.responseMessage = { success: false, message: errorMessage };
        this.sharedService.setResponseMessage(this.responseMessage);
      } else {
        this.authenticationService.setLoggedInUser(reponseInFo);
        this.permissionModules = reponseInFo.modules.map((data: any) => data.name);
        if (this.permissionModules.includes('REPORT')) {
          localStorage.setItem('lastReportUrl', '/reports/device/message-count');
        }
        this.sharedService.setAccessRole(reponseInFo.modules, this.permissionModules);
        let permissionModules = JSON.parse(localStorage.getItem('permissionModules') || '[]');
        this.sharedService.setDefaultUrl(permissionModules);
        // window.location.reload();
        localStorage.removeItem('reports');
        localStorage.removeItem('dashboards');
        localStorage.removeItem('viewReport');
        localStorage.removeItem('reportData');
        localStorage.removeItem('currentReport');
        localStorage.removeItem('reportsVehicle');
        localStorage.removeItem('unreadNotification');
        localStorage.setItem('impersonate', 'true');
        // Set support view mode flag
        localStorage.setItem("supportViewMode", "true");
        // Navigate directly to /chargers instead of reloading
        this.router.navigate(["/chargers"]);
      }
    }, (error) => {
      this.sharedService.getErrorMsg(error);
    });
  }

  clear() {
    this.searchModel.supportTypeVal = '';
    localStorage.removeItem('supportSearch');
  }

  ngOnDestroy() {
    if (this.searchModel.supportTypeVal === '') {
      localStorage.removeItem('supportSearch');
    }
  }

  openJiraTicketModal() {
    this.jira = {
      customerAccountId:"",
      customerEmail:"",
      description: "",
      attachments: [],
    };
    this.showJiraTicketModal = true;
  }

  closeJiraTicketModal() {
    this.showJiraTicketModal = false;
  }

  createJiraTicket(form: NgForm) {
    if (form.valid && this.jira.customerAccountId && this.jira.customerEmail) {
      console.log("Creating Jira ticket with data:", this.jira);
      // Here you would typically call a service to create the ticket
      this.closeJiraTicketModal();
    }
  }

  updateCharCount() {
    // This method is called on input change to satisfy the template,
    // but the character count is handled directly in the template.
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    if (dropZone) {
      dropZone.classList.add("drag-over");
    }
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    if (dropZone) {
      dropZone.classList.remove("drag-over");
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    if (dropZone) {
      dropZone.classList.remove("drag-over");
    }

    const files = event.dataTransfer!.files;
    if (files) {
      this.handleFiles(files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.handleFiles(input.files);
      input.value = ""; // Reset file input
    }
  }

  handleFiles(files: FileList) {
    const allowedTypes = [
      "image/png",
      "image/jpeg",
      "application/pdf",
      "text/plain",
      "application/zip",
      "application/x-zip-compressed",
    ];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      // Simple validation for file types, you might want to make this more robust
      if (this.jira.attachments.findIndex((f) => f.name === file.name) === -1) {
        this.jira.attachments.push(file);
      }
    }
  }

  removeAttachment(index: number) {
    this.jira.attachments.splice(index, 1);
  }

  ngAfterViewChecked() {
    if (this.users.length > 0 || this.devices.length > 0 || this.vehicles.length > 0) {
      requestAnimationFrame(() => {
        this.syncDatatableHeaderWidth();
      });
    }
  }

  // Sync datatable header width with body width to fix width mismatch
  syncDatatableHeaderWidth() {
    const datatables = document.querySelectorAll('.ngx-datatable.scroll-horz');

    datatables.forEach((datatable) => {
      const body = datatable.querySelector('datatable-body') as HTMLElement;
      const header = datatable.querySelector('datatable-header') as HTMLElement;
      const headerInner = header?.querySelector('.datatable-header-inner') as HTMLElement;

      if (body && headerInner) {
        const bodyWidth = body.offsetWidth;
        const currentHeaderWidth = headerInner.offsetWidth || headerInner.clientWidth;
        if (bodyWidth > 0 && Math.abs(bodyWidth - currentHeaderWidth) > 1) {
          headerInner.style.width = bodyWidth + 'px';
          headerInner.style.minWidth = bodyWidth + 'px';
          headerInner.style.maxWidth = bodyWidth + 'px';
          if (header) {
            header.style.width = bodyWidth + 'px';
          }
          void headerInner.offsetHeight;
        }
      }
    });
  }
}